import Button from "components/shared/button";
import useTranslation from "utils/hooks/useTranslation";

export interface CommandPanelToolbarProps {
  save?: () => any;
  saveAndClose?: () => void;
  additionalElement?: React.ReactElement;
  isDisabledMode?: boolean;
}

export const CommandPanelToolbar: React.FC<CommandPanelToolbarProps> = ({
  save,
  saveAndClose,
  additionalElement,
  isDisabledMode,
}) => {
  const { t } = useTranslation();

  return (
    <group
      data-space="20"
      data-space-horizontal="40"
      //data-border=""
      data-align="center"
      data-gap="20"
      data-wrap="no"
    >
      {saveAndClose ? (
        <Button primary onClick={saveAndClose} disabled={isDisabledMode}>
          <text>{t("SaveAndClose")}</text>
        </Button>
      ) : null}
      {save ? (
        <Button highlight onClick={save} disabled={isDisabledMode}>
          <text>{t("Save")}</text>
        </Button>
      ) : null}
      {additionalElement ?? null}
    </group>
  );
};
